var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-2",modifiers:{"modal-2":true}}]},[_vm._v("Terms of Use")]),_c('b-modal',{attrs:{"id":"modal-2","size":"xl","title":"Terms of Use"}},[_c('appTermsOfUse')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }